<template>
  <div class="benefitsCard">
    <h5>{{ header }}</h5>

    <h3 class="text-primary mt-3">Kr {{ amount }}</h3>

    <p>Per leieforhold / måned</p>
    <hr />

    <p class="mt-5">{{ benefits.title }}</p>
    <div class="benefitsCard__benefits">
      <div v-for="(benefit, index) in benefits.items" :key="index">
        <i class="budicon-check-ui text-primary" />
        <span>{{ benefit }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'Card',
  props: {
    header: {
      type: String,
      required: true,
    },
    amount: {
      type: String,
      required: true,
    },
    benefits: {
      type: Object,
      required: true,
    },
  },
});
</script>

<style lang="scss" scoped>
.benefitsCard {
  padding: 3rem 10rem 3rem 3rem;
}
.benefitsCard__benefits {
  display: flex;
  flex-direction: column;
  gap: 1rem 0rem;
  margin-top: 1rem;
}
.benefitsCard__benefits div {
  display: flex;
  align-items: center;
  gap: 0rem 0.4rem;
}
.benefitsCard__benefits div i {
  font-size: 1.4rem;
}

@media only screen and (min-width: 600px) {
  .benefitsCard {
    padding: 3rem 10rem 3rem 3rem;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.07);
  }
}
</style>
